export default __webpack_public_path__ + "static/media/trash.203ed13e.svg";